import { Box, Flex } from '@chakra-ui/react';
import { useRef, useState, useLayoutEffect } from 'react';

import EditableTitle from '../../EditableTitle';

import { KpiInstrument } from './KpiInstrument';
import { ChartInstrument } from './ChartInstrument';
import { TableInstrument } from './TableInstrument';
import { VarianceInstrument } from './VarianceInstrument';
import { BaseInstrumentProperties } from './proptypes';

const ExportInstruments = ({ widget, output }: BaseInstrumentProperties) => {
  const parentReference = useRef<HTMLDivElement>(null);
  const [parentWidth, setParentWidth] = useState(0);

  useLayoutEffect(() => {
    const updateWidth = () => {
      if (parentReference.current) {
        setParentWidth(parentReference.current.offsetWidth);
      }
    };

    updateWidth();
    const resizeObserver = new ResizeObserver(() => {
      updateWidth();
    });

    if (parentReference.current) {
      resizeObserver.observe(parentReference.current);
    }

    return () => resizeObserver.disconnect();
  }, []);

  const renderInstrument = () => {
    switch (widget?.instrument_type) {
      case 'kpi':
        return <KpiInstrument widget={widget} output={output} />;
      case 'line':
      case 'bar':
      case 'stack':
        return <ChartInstrument widget={widget} output={output} />;
      case 'table':
        return <TableInstrument widget={widget} output={output} />;
      case 'variance':
        return <VarianceInstrument widget={widget} output={output} />;
      default:
        return null;
    }
  };

  return (
    <Box height='100%' padding='0.6rem' width='100%'>
      <Flex justifyContent='space-between' ref={parentReference}>
        <Flex width='calc(100% - 40px)' height='40px' alignItems='center' pb={5}>
          <EditableTitle
            value={widget?.name}
            handleChange={() => {}} // Read-only in export view
            isEditable={false}
            width={parentWidth - 40 > 0 ? `${parentWidth - 40}px` : '0px'}
          />
        </Flex>
      </Flex>
      <Box height='calc(100% - 30px)' position='relative' className='scroll' overflow='auto'>
        {renderInstrument()}
      </Box>
    </Box>
  );
};

export default ExportInstruments;
